import React, { Component } from 'react';
import Vas from "./Vas";
import './css/OfflineMenu.css';

import { Icon } from "component-lib";
import SideNavigationOffline from './custom_controls/SideNavigationOffline';

class OfflineMenu extends Component{

    constructor(props){
        super(props);
        this.state = {};
        this._isMounted = false;
        this.state.bar = true;
    }

    logout(){
        Vas.Signout();
    };

    render(){
      
        return (
          <div className={"OfflineMenu"}>
            <center>
              <table>
                <tbody>
                  <tr >
                    <td style={{ width:'100%' }}>
                      <div>
                        <table style={{ margin:'auto' }}>
                          <tbody>
                            <tr>
                              <td><img
                                className={"DbLogo"}
                                src={document.location.origin +"/images/DBLogo.png"}
                                alt={"Systemtechnik_Logo"} /></td>
                              <td
                                id="OrderSchoolTicketDataLink"
                                className={"OfflineMenuItem"}
                                onClick={()=>{ Vas.GetView("Order", null, false); }}>
                                  {Vas.Resources.Menus["OrderSchoolTicket"]}
                              </td>
                              <td
                                id="LoginDataLink"
                                className={"OfflineMenuItem"}
                                onClick={()=>{ Vas.GetView("Login",null, false); }}>{Vas.Resources.Menus["Login"]}
                              </td>
                              <td
                                id="ImprintDataLink"
                                className={"OfflineMenuItem"}
                                onClick={()=>{ Vas.GetView("Impressum",null, false); }}>{Vas.Resources.Menus["Impressum"]}
                              </td>
                              
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                    <td style={{ width:'40px' }}>
                      <div style={{ textAlign:'right' }}>
                        <table>
                          <tbody>
                            <tr>
                              <td className={"BurgerMenu"}><Icon
                                Id={"BurgerMenu"}
                                Name={"Menu"}
                                Size={36}
                                Color={"white"} /><SideNavigationOffline /></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </div>
        );
    }
}
export default OfflineMenu;
